const keys = {
	consultants: () => ["consultants"] as const,
};

export default keys;
